/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_View_LineInputs */

const en_admin_ai_chat_view_line = /** @type {(inputs: Admin_Ai_Chat_View_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Line`)
};

const de_admin_ai_chat_view_line = /** @type {(inputs: Admin_Ai_Chat_View_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linie`)
};

const es_admin_ai_chat_view_line = /** @type {(inputs: Admin_Ai_Chat_View_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Líneas`)
};

const fr_admin_ai_chat_view_line = /** @type {(inputs: Admin_Ai_Chat_View_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lignes`)
};

const nl_admin_ai_chat_view_line = /** @type {(inputs: Admin_Ai_Chat_View_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lijn`)
};

/** @type {(inputs: Admin_Ai_Chat_View_LineInputs) => LocalizedString} */
const it_admin_ai_chat_view_line = en_admin_ai_chat_view_line;

/** @type {(inputs: Admin_Ai_Chat_View_LineInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_view_line = en_admin_ai_chat_view_line;

/** @type {(inputs: Admin_Ai_Chat_View_LineInputs) => LocalizedString} */
const pl_admin_ai_chat_view_line = en_admin_ai_chat_view_line;

/** @type {(inputs: Admin_Ai_Chat_View_LineInputs) => LocalizedString} */
const hu_admin_ai_chat_view_line = en_admin_ai_chat_view_line;

/** @type {(inputs: Admin_Ai_Chat_View_LineInputs) => LocalizedString} */
const ro_admin_ai_chat_view_line = en_admin_ai_chat_view_line;

/**
* | output |
* | --- |
* | "Line" |
*
* @param {Admin_Ai_Chat_View_LineInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_view_line = /** @type {((inputs?: Admin_Ai_Chat_View_LineInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_View_LineInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_view_line(inputs)
	if (locale === "de") return de_admin_ai_chat_view_line(inputs)
	if (locale === "es") return es_admin_ai_chat_view_line(inputs)
	if (locale === "fr") return fr_admin_ai_chat_view_line(inputs)
	if (locale === "nl") return nl_admin_ai_chat_view_line(inputs)
	if (locale === "it") return it_admin_ai_chat_view_line(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_view_line(inputs)
	if (locale === "pl") return pl_admin_ai_chat_view_line(inputs)
	if (locale === "hu") return hu_admin_ai_chat_view_line(inputs)
	return ro_admin_ai_chat_view_line(inputs)
});
export { admin_ai_chat_view_line as "admin.ai_chat.view_line" }